
















































































































































































































































































































































































































































































































































































import { Component, Mixins, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import {
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    // VehicleStoreHelper,
    AuthStoreHelper
} from '../../core/mixins';
import { SettingsService } from '../api/SettingsService';
import VariableGroupConfiguration from './VariableGroupConfiguration.vue';
import ListParameterValue from './ListParameterValue.vue';
import VehiclesActions from './VehiclesActions.vue';
import ModalVehicleBroadcasts from './ModalVehicleBroadcasts.vue';
import ModalVehicleFTP from './ModalVehicleFTP.vue';
import VehicleAlerts from './VehicleAlerts.vue';
import multiselect from 'vue-multiselect';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Button from '../../core/components/Button.vue';
import { MultipleSelect } from '../../core/components';
import { EventBus, formatComplexList, formatDate, getIndexFromList, NAME_ROUTES, TypeEventBus } from '../../core/utils';
import ChangeDeviceDialog from './ChangeDeviceDialog.vue';
import PhoneNumber from './PhoneNumber.vue';
import { Alarm } from '../models/Alarm';
import Loading from 'vue-loading-overlay';
import { NormsServices } from '../../norms/api/NormsServices';
import { ContextMenu } from '../../core/components';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Input from '../../core/components/Input.vue'; 
import InfoIcon from '../../core/components/InfoIcon.vue';
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import { BroadcastsTypes } from '../../core/models/Vehicle';
import { variableGroupDevicesInfo } from '../../norms/utils';

@Component({
    name: 'VehicleDetail',
    components: {
        ContextMenu,
        VariableGroupConfiguration,
        ListParameterValue,
        Loading,
        multiselect,
        MultipleSelect,
        ConfirmAction,
        ChangeDeviceDialog,
        PhoneNumber,
        SectionTitle,
        Button,
        VehiclesActions,
        Input,
        InfoIcon,
        SimpleTable,
        ModalVehicleBroadcasts,
        VehicleAlerts,
        ModalVehicleFTP
    }
})
export default class Vehicles extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    // VehicleStoreHelper,
    AuthStoreHelper
) {
    @Prop({ default: () => false })
    createVehicle: boolean;

    @Prop({ default: '' }) vehicleToEditId: string;

    @Prop({ default: () => {} })
    vehicleProperties: any;

    simList: any = [];
    serviceProviderList: Array<object> = [];

    norm: number | string = 0;
    minLoadWeight: number | string | null = null;
    tooltipMinLoadWeight: string = 'Valor mínimo de la variable "peso" para considerar el vehículo como cargado';

    selectedVariableGroups: any[] = [];

    show: boolean = false;
    showParameterValueList: boolean = false;
    workAreaCalculation: boolean = false;

    showPhoneNumberModal: boolean = false;

    pendingRequest: boolean = false;

    selectedVehicleForEdition: any = {};

    visibleVehicleBroadcasts: boolean = false;
    visibleVehicleFtp: boolean = false;
    showChangeDeviceModal: boolean = false;


    visiblePatchConfirmAction: boolean = false;
    visiblePhoneNumberConfirmation: boolean = false;
    isSelection: boolean = false;
    itemToAddOrRemove: any = {};
    phoneNumberToSelect: any = {};

    variableGroupList: any[] = [];

    mtop_regid: number | null | boolean = null;

    AlarmsList: Alarm[] = [];

    loaded: boolean = false;

    optionsToSelect: any = [];
    preselectOptions: any = [];
    showMultiSelect: boolean = true;

    selectedSim: object | null = null;
    variableGroups: any[] = [];
    description: string = '';
    vehiclePlate: string = '';
    mhBroadcastNumber: any | null = null;
    vin: string | null = null;
    vehicleType: any = {};
    deviceType: any = {};
    enabledMHBroadcast: boolean = false;
    companies: any = [];
    latu_regid: string | null = null;

    activationVehicleStatus: number | null = null;
    activationVehicleStatusMsg: string = '';
    msgInfo: string = variableGroupDevicesInfo;

    variableConfigurationList: any[] = [];
    historicalNormList: any[] = [];

    showAddModal: boolean = true;

    variableGroupsAlertsList: any[] = [];

    parameterVersionList: any[] = [];

    waitingVariableGroupsAlertList: boolean = false;
    waitingVariableConfigurationList: boolean = false;
    waitingHistoricalNormList: boolean = false;
    searchVar: string = '';
    searchAlerts: string = '';
    phoneNumber: string = '';
    iccid: string = '';
    serviceProvider: number = 0;

    originalList: Array<object> = [];
    greenmileNumber: any | null = null;
    debug: boolean = false;
    send_im: boolean = false;
    siporal_broadcast: boolean = false;

    headers: Array<object> = [
        {
            text: 'Tipo',
            align: 'left',
            value: 'type'
        },
        {
            text: 'Estado',
            align: 'left',
            value: 'active'
        },
        {
            text: '# Vehiculos',
            align: 'left',
            value: 'vehicles_count'
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Condición',
            align: 'left',
            value: 'condition'
        },
        {
            text: 'Fecha de creación',
            align: 'left',
            value: 'creation_date',
            formatter: this.format
        },
        {
            text: 'Acciones',
            align: 'left ',
            value: 'actions',
            sortable: false
        }
    ];

    enabledGreenMile: boolean = false;

    historicalNormHeaders: Array<object> = [
        {
            text: 'Id Norma',
            align: 'left',
            value: 'norm_version.id'
        },
        {
            text: 'Descripción',
            align: 'left',
            value: 'norm_version.description'
        },
        {
            text: 'Fecha activación',
            align: 'left',
            value: 'timestamp',
            formatter: this.format
        },
        {
            text: 'Estado',
            align: 'left',
            value: 'active'
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions'
        }
    ];

    headersOfVariableConfigurationTable: Array<object> = [
        {
            text: 'Ecu',
            align: 'left',
            value: 'ecu',
            width: '80px'
        },
        {
            text: 'Variable ID',
            align: 'left',
            value: 'variable_id',
            width: '100px'
        },
        {
            text: 'Variable',
            align: 'left',
            value: 'variable',
            width: '250px'
        },
        {
            text: 'Clasificación',
            align: 'left',
            value: 'classification',
            width: '150px'
        },
        {
            text: 'Estado',
            align: 'left',
            value: 'confirmed',
            width: '100px'
        }
    ];

    headersOfWarningsConfiguration: Array<object> = [
        {
            text: 'Variable',
            align: 'left',
            value: 'variable'
        },
        {
            text: 'Clasificación',
            align: 'left',
            value: 'classification'
        },
        {
            text: 'Alerta',
            align: 'left',
            value: 'alert'
        }
    ];
    visibleModalDeactivateNorm: boolean = false;
    confirmMessageDeactivateNorm: string = this.getDeactivateNormCautionMessage();

    updateMinLoadWeight(value) {
        this.minLoadWeight = value;
    }

    getDeactivateNormCautionMessage(){
        return '¿Está seguro que desea desactivar la Norma a este vehículo?<br> Consecuencias que tendrá esta acción:<br> <li>El vehículo no tendrá ninguna norma activa</li> <li>Se desactivarán todas las Variables</li> <li>Se desactivarán todas las Alarmas</li> <li>No podrá activar variables para este vehículo (Se conservan los Grupos de variables)</li> <li>No podrá setear parameter values</li>'
    }

    confirmDeactivateNorm(){
        this.visibilityModalDeactivateNorm(false);
        let data = {
            vehicle_ids: [Number(this.vehicleToEditId)]
        }
        this.waitingHistoricalNormList = true;
        SettingsService.deactivateVehicleNorm(
            data
        ).then((res) => {
            this.getHistoricalNorm();
        }).catch((err) => {
            this.waitingHistoricalNormList = false;
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo desactivar la Norma'
            });
        })
    }

    visibilityModalDeactivateNorm(value){
        this.visibleModalDeactivateNorm = value;
    }

    @Emit()
    updateVehiclesList(){}
    
    @Emit()
    deactivateAlertsSuccess(vehicleIds: number[], acknowledgeDate: string | null){}

    @Emit()
    closeModal(){}

    getTitleVariableGroupsOption(variable_classifications){
        if(variable_classifications && variable_classifications.length){
            return formatComplexList(variable_classifications, 'description')
        }
        return ''
    }

    @Watch('showAddModal')
    modalVisibleObservable(value) {
        if (!value) this.closeModal();
    }

    vehicleTypeList: any = [];
    deviceTypeList: any = [];
    contextMenuItem: any = [];
    rightClickEvent: any = null;
    showContextMenu: boolean = false;
    loadingFtpData: boolean = false;
    ftpData: object = {};


    data() {
        return {
            descriptionRules: {
                required: value => !!value || 'La descripción no puede estar vacía'
            },
            vehiclePlateRules: {
                required: value => !!value || 'La matricula no puede estar vacía',
                counter: value => value.length <= 30 || 'La matricula debe tener menos de 31 caracteres'
            }
        };
    }

    getConfirmActionDataForMessageOfPhoneNumber(value) {
        let itemData = this.phoneNumberToSelect.vehicle;
        if (itemData) return this.phoneNumberToSelect.vehicle[value];
    }

    updateBroadcastsFields(broadcastFields){
        this.send_im = broadcastFields.send_im;
        this.mhBroadcastNumber = broadcastFields.mh_broadcast_id;
        this.greenmileNumber = broadcastFields.greenmile_id;
        this.siporal_broadcast = broadcastFields.siporal_broadcast;
    }

    searchChange(searchQuery: string, id: any) {
        if (this.originalList.length == 0) {
            this.originalList = [...this.simList];
        }
        if (searchQuery) {
            let newSimList = this.simList.filter(phone => this.filterHandler(phone, searchQuery));
            this.assignSimList(newSimList);
        } else {
            this.assignSimList(this.originalList);
        }
    }

    filterHandler(phone: any, queryText: string): boolean {
        let queryTextLowerCase = queryText.toLocaleLowerCase();
        let phoneNumber =
            phone && phone.phone_number
                ? phone.phone_number
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;
        let phoneIccid =
            phone && phone.iccid
                ? phone.iccid
                      .toString()
                      .toLocaleLowerCase()
                      .includes(queryTextLowerCase)
                : false;

        return phoneNumber || phoneIccid;
    }

    clickDeactivateNorm(){
        this.visibilityModalDeactivateNorm(true);

    }

    openPhoneNumberModal() {
        this.showPhoneNumberModal = true;
    }

    getVariableGroupById(id) {
        return this.variableGroupList.filter(variable => variable.id == id);
    }

    getCompleteInformationOfSelectedVariableGroup() {
        this.selectedVariableGroups = this.variableGroups
            .map(variable => this.getVariableGroupById(variable.id))
            .flat();
    }

    showAlarm(item) {
        this.$router.push(NAME_ROUTES.ALARMS.path + 'edit/' + item.id);
    }

    rightClickEditAlarm(event, item) {
        this.contextMenuItem = [];
        this.contextMenuItem.push({
            title: 'Abrir en una nueva pestaña',
            link: {
                path: '/settings/alarms/' + 'edit/' + item.id,
                target: '_blank'
            }
        });
        this.rightClickEvent = event;
        this.showContextMenu = true;
    }

    rightClickCreateAlarm(event) {
        this.contextMenuItem = [];
        this.contextMenuItem.push({
            title: 'Abrir en una nueva pestaña',
            link: {
                path: '/settings/alarms/add',
                target: '_blank'
            },
            disabled: false
        });
        this.rightClickEvent = event;
        this.showContextMenu = true;
    }

    closeContextMenu() {
        this.showContextMenu = false;
    }

    visibilityModalVehicleBroadcasts(value){
        this.visibleVehicleBroadcasts = value;
    }

    visibilityModalVehicleFtp(value){
        this.visibleVehicleFtp = value;
    }

    clickSetBroadcasts(){
        this.visibilityModalVehicleBroadcasts(true);
    }

    clickSetFtp(){
        this.visibilityModalVehicleFtp(true);
    }

    addAlarm() {
        // this.$_setVehicleId(Number(this.vehicleToEditId))
        // this.$router.push(NAME_ROUTES.ALARMS.path);
        this.$router.push(NAME_ROUTES.ALARMS.path + 'add');
    }


    openAddModal() {
        this.showChangeDeviceModal = true;
    }

    configureVariableGroup() {
        this.getVariableConfigurationList();
        this.variableGroupDialog(true);
    }

    variableGroupDialog(value) {
        this.show = value;
    }

    close() {
        this.show = false;
        this.showPhoneNumberModal = false;
    }

    loadingAnimation(value){
        this.pendingRequest = value
    }

    handleMultiselect() {
        this.$_enableListenkey();
    }

    updateSelectedSim(value: object | null){
        this.selectedSim = value
    }

    closeAddPhoneConfirmationDialog(confirm: boolean) {
        if (confirm) {
            //preselecciono el sim anterior si no se confirma el cambio
            this.updateSelectedSim(this.phoneNumberToSelect);
        }
        this.visiblePhoneNumberConfirmation = false;
    }

    selectPhoneNumberByUser(selectedPhone) {
        this.phoneNumberToSelect = selectedPhone;
        if (!selectedPhone.vehicle) {
            this.updateSelectedSim(selectedPhone);
            return
        };
        this.visiblePhoneNumberConfirmation = true;
    }

    getVehicleVin(item) {
        return this.getResponseDefaultVariable(item, 'vin');
    }

    getResponseDefaultVariable(response, variableName) {
        if (this.objectIsEmpty(response) || !response) return '';
        return response[variableName];
    }

    get modalVehicleBroadcasts(): HTMLFormElement {
        return this.$refs.popupVehicleBroadcasts as HTMLFormElement;
    }

    get canViewActions(){
        return !this.createVehicle && this.$_userIsSmartway
    }

    objectIsEmpty(obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return false;
            }
        }

        return JSON.stringify(obj) === JSON.stringify({});
    }

    removeSelectedDeviceType() {
        this.deviceType = null;
    }

    removeSelectedVehicleType() {
        this.vehicleType = null;
    }

    getDataAvoidErrors(variableName) {
        if (this.objectIsEmpty(variableName) || !variableName) return null;
        return Number(variableName.id);
    }

    toggleMtopRegId(value: boolean | null){
        this.mtop_regid = value;
    }

    putMultiselectOptions() {
        this.vehicleTypeList = Object.entries(this.vehicleProperties.all_vehicle_types).map(([key, value]) => ({
            label: value,
            id: key
        }));

        this.deviceTypeList = Object.entries(this.vehicleProperties.all_hardware_types).map(([key, value]) => ({
            label: value,
            id: key
        }));
    }

    submitVehicle() {
        if (this.createVehicle) {
            this.postVehicle();
        } else {
            this.patchVehicle();
        }
    }

  
    

    get getStylesForSaveButton() {
        if (!this.createVehicle) {
            return 'position: absolute; top: -20px;';
        } else {
            return 'position: absolute;';
        }
    }

    get canSaveVehicle() {
        return Boolean(
            this.description &&
                this.vehiclePlate &&
                this.vehiclePlate.length <= 30 &&
                this.getDataAvoidErrors(this.vehicleType) &&
                (this.companies.length || this.preselectOptions.length)
        );
    }

    get getUserCompanies() {
        return this.optionsToSelect;
    }

    get getPreselectedOptions() {
        return this.preselectOptions;
    }

    handleSelected(itemToAdd) {
        this.preselectOptions.push(itemToAdd);
    }

    handleRemoveOption(itemToRemove) {
        this.preselectOptions = this.preselectOptions.filter(item => item.id !== itemToRemove.id);
    }

    actionInSelect(itemToAdd) {
        this.itemToAddOrRemove = itemToAdd;
        this.isSelection = true;
        this.visiblePatchConfirmAction = true;
    }

    actionInRemove(itemToRemove) {
        this.itemToAddOrRemove = itemToRemove;
        this.isSelection = false;
        this.visiblePatchConfirmAction = true;
    }

    getVariableGroupConfiguration(parameterVersionList) {
        this.parameterVersionList = parameterVersionList.parameter_version_list;
    }

    //TODO
    async patchVariableConfiguration() {
        try {
            this.loadingAnimation(true);
            let parameterVersionIdAndVehicleId: any = {
                parameter_version_list: this.parameterVersionList,
                vehicle_id: this.vehicleToEditId
            };
            const response = await NormsServices.patchVariableConfiguration(parameterVersionIdAndVehicleId);
            this.loadingAnimation(false);
            this.$_successPatchRecipients(response.message);
        } catch (e) {
            this.$_showHistoricalError(e);
            this.loadingAnimation(false);
        }
        this.close();
        this.reloadVariablesData();
    }

    updatePhoneData(data) {
        this.phoneNumber = data.phoneNumber;
        this.iccid = data.iccid;
        this.serviceProvider = data.serviceProvider;
    }

    ImportExcel(data) {
        this.loadingAnimation(true)
        const formData = new FormData();
        formData.append('file', data.file);
        formData.append('absolute', data.absolute);
        
        SettingsService.ImportExcel(
            formData
        ).then((res) => {
            this.loadingAnimation(false)
            this.$_successPatchRecipients(res.message);
            this.getSIMData();
            this.close();
        }).catch((error) => {
            this.loadingAnimation(false)
            this.$_catchLoadingDialog({
                response: error.data || {},
                alternative_msg: 'No se pudieron cargar los teléfonos'
            });
        })
    }

    async postPhone() {
        try {
            this.loadingAnimation(true);

            let phoneData = {
                phone_number: this.phoneNumber,
                iccid: this.iccid,
                service_provider: this.serviceProvider
            };
            const response = await SettingsService.createSim(phoneData);
            this.loadingAnimation(false);
            this.$_successPatchRecipients(response.message);
            await this.getSIMData();
            this.preselectSim(response.SIM.id);
            this.close();
        } catch (e) {
            this.loadingAnimation(false);
            let msg = 'No se pudo agregar el teléfono';
            if (e && e.data && e.data.message) {
                msg = e.data.message;
            }
            this.$_showHistoricalError(msg);
        }
    }

    async patchConfirmationDialog(confirm: boolean) {
        if (confirm) {
            try {
                this.loadingAnimation(true);
                let variablesGroupsList = [...this.selectedVariableGroups];
                if (this.isSelection) {
                    variablesGroupsList.push(this.itemToAddOrRemove);
                } else {
                    variablesGroupsList = variablesGroupsList.filter(item => item.id !== this.itemToAddOrRemove.id);
                }
                let variableGroupListPayload: any = {
                    variable_group_list: variablesGroupsList.map(group => group.id)
                };
                const response = await NormsServices.patchGroupsToOneVehicles(
                    this.vehicleToEditId,
                    variableGroupListPayload
                );
                this.getVariableConfigurationList();
                this.getVariableGroupsAlerts();
                this.selectedVariableGroups = variablesGroupsList;
                this.$_successPatchRecipients(response.message);
                this.loadingAnimation(false);
            } catch (e) {
                this.loadingAnimation(false);
                this.$_showHistoricalError(e);
            }
        }
        this.loadingAnimation(false);
        this.visiblePatchConfirmAction = false;
    }

    async getVariableGroupList() {
        NormsServices.getVariableGroupList()
            .then(data => {
                this.variableGroupList = data.variablegroups;
                this.getCompleteInformationOfSelectedVariableGroup();
            })
            .catch(err => {
                this.$_errorPatchRecipients(err);
            });
    }

    async getVariableGroupsAlerts() {
        try {
            this.loadingAnimation(true);
            const response = await NormsServices.getVariableGroupsAlerts(this.vehicleToEditId);
            this.loadingAnimation(false);
            this.variableGroupsAlertsList = response;
        } catch (e) {
            this.$_showHistoricalError(e);
        }
        this.loadingAnimation(false);
    }

    assignSimList(list) {
        if(list.length > 0){
            list = list.sort((a, b) => b.id - a.id)
        }
        this.simList = list;
    }

    get getSimList() {
        return this.simList.filter(function(item) {
            if (item && item.id) {
                return item;
            }
        });
    }

    async getSIMData() {
        try {
            this.waitingVariableGroupsAlertList = true;
            const response = await SettingsService.getSIMData();
            this.assignSimList(response);
        } catch (e) {
            this.$_showHistoricalError(e);
        }
        this.waitingVariableGroupsAlertList = false;
    }

    getFtpData(vehicleId) {
        this.loadingFtpData = true;
        NormsServices.getFtpData(vehicleId)
            .then(data => {
                this.ftpData = data;
            })
            .catch(err => {
                this.$_errorPatchRecipients(err);
            }).finally(() => {
                this.loadingFtpData = false;
            });
    }

    async getVehicleById() {
        await this.getSIMData();
        this.$emit('submitChange');
        
        if( this.vehicleToEditId !== ''){
            this.getFtpData(this.vehicleToEditId)
            this.loadingAnimation(true);
            const response = await SettingsService.getVehicleById(this.vehicleToEditId);
            this.loadingAnimation(false);
            this.selectedVehicleForEdition = response;
            this.variableGroups = response.variable_groups;
            this.description = response.description;
            this.vehiclePlate = response.vehicle_plate;
            this.vin = response.vin;
            this.vehicleType = {
                id: response.vehicle_type,
                label: this.vehicleProperties.all_vehicle_types[response.vehicle_type]
            };
            this.deviceType = {
                id: response.device_type,
                label: this.vehicleProperties.all_hardware_types[response.device_type]
            };
            this.preselectSim(response.sim_id);

            if(response['greenmile_id'] !== null){
                this.modalVehicleBroadcasts.updateGreenmileFields(response['greenmile_id']);
            }
            if(response['mh_broadcast_id'] !== null){
                this.modalVehicleBroadcasts.updateMhBroadcastFields(response['mh_broadcast_id'] )
            }
            this.workAreaCalculation = response['work_area_calculation'];
            this.latu_regid = response.latu_regid;

            this.preselectOptions = this.optionsToSelect.filter(option => response.companies.includes(Number(option.id)));

            this.activationVehicleStatus = response.activation_status;
            this.activationVehicleStatusMsg = this.vehicleProperties.all_activation_status[response.activation_status];
            this.workAreaCalculation = response.work_area_calculation;
            this.modalVehicleBroadcasts.updateSendImFields(response.send_im)
            this.modalVehicleBroadcasts.updateSiporalFields(response.siporal_broadcast);
            this.debug = response.debug;
        }
    }

    preselectSim(simId: null | string){
        if(simId == null){
            this.selectedSim = null;
            return
        }

        if(this.simList &&  this.simList.length !== 0){
            let indexPhoneNumber = getIndexFromList(this.simList, 'id', simId);
            if(indexPhoneNumber !== -1){
                this.selectedSim = this.simList[indexPhoneNumber];
            }
        }
    }

    removeItemFromArray(array, item) {
        const index = array.indexOf(item);

        if (index > -1) {
            array.splice(index, 1);
        }
    }

    putItemFirstInArray(array, item) {
        this.removeItemFromArray(array, item);
        array.unshift(item);
    }

    async getAlarmsListByVehicleId() {
        const response = await SettingsService.getAlarmsListByVehicleId(this.vehicleToEditId);
        this.AlarmsList = response;
    }

    async getVariableConfigurationList() {
        try {
            this.waitingVariableConfigurationList = true;
            const response = await NormsServices.getVariableConfigurationList(this.vehicleToEditId);
            this.variableConfigurationList = response;
        } catch (e) {
            this.$_showHistoricalError(e);
        }
        this.waitingVariableConfigurationList = false;
    }

    async getHistoricalNorm() {
        try {
            this.waitingHistoricalNormList = true;
            this.historicalNormList = [];
            const response = await NormsServices.getHistoricalNorm(this.vehicleToEditId);
            let historicalList = response.historical_list;
            if(historicalList.length > 0){
                let indexActiveNorm = historicalList.findIndex(norm => norm.active == true);
                if(indexActiveNorm !== -1){
                    this.norm = historicalList[indexActiveNorm].norm_version.id;
                }else{
                    this.norm = 'Vehículo sin norma activa';
                }
            }
            this.historicalNormList = historicalList;
            this.showParameterValueList = true;
        } catch (e) {
            this.$_showHistoricalError(e);
        }
        this.waitingHistoricalNormList = false;
    }

    get vehicleHasActiveNorm(){
        return typeof this.norm === 'number' ? true : false
    }

    get getAlarms() {
        return this.AlarmsList;
    }

    updateVehicleActivationStatus(activationStatus, msg){
        this.activationVehicleStatus = activationStatus;
        this.activationVehicleStatusMsg = msg;
    }

    updateParameterValueList(){
        this.showParameterValueList = false;

        setTimeout(() => {
            this.showParameterValueList = true;
        }, 0);
    }




    reloadVariables(){
        this.getVariableConfigurationList();
        this.getVariableGroupsAlerts();

    }




    reloadVariablesData() {
        if (this.vehicleToEditId == null || this.vehicleToEditId === '') return
        if (this.createVehicle) return 
        this.getVariableConfigurationList();
        this.getVariableGroupsAlerts();
        this.getVariableGroupList();
    }

    async reloadAll() {
        this.loadingAnimation(true);
        this.putMultiselectOptions();
        this.optionsToSelect = this.$_getCompanies;
        if (this.$_userIsSmartway) this.getSIMData();
        if (this.vehicleToEditId != null) {
            await this.getVehicleById();
            if (!this.$_userIsSmartway) return;
            this.reloadVariablesData();
        }
        this.loadingAnimation(false);
    }

    format(date: string) {
        return formatDate(date);
    }

    @Watch('loaded')
    getPrivileges() {
        if (!this.loaded) return;
        this.reloadAll();
        if (!this.createVehicle && this.shouldDeleteVehicles) {
            this.getAlarmsListByVehicleId();
            this.getHistoricalNorm();
        }
    }

    get shouldDeleteVehicles(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.READ) && this.$_userIsSmartway;
    }

    mounted() {
        this.loaded = true;
        if(!this.createVehicle){
            this.loadingAnimation(true);
        }
        SettingsService.getVehiclesServiceProvider(false)
            .then(res => {
                this.serviceProviderList = res;
            })
            .catch(res => {
                this.serviceProviderList = [];
            });
    }

    updateDescription(value){
        this.description = value;
    }
    updateVehiclePlate(value){
        this.vehiclePlate = value;
    }
    updateVehicleVin(value){
        this.vin = value;
    }
    updateLatuRegId(value){
        this.latu_regid = value;
    }
    
    updateSearchVar(value){
        this.searchVar = value;
    }
    updateSearchAlerts(value){
        this.searchAlerts = value;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }

    getDataForNulleableText(variable) {
        if (variable == '') return null;
        return variable;
    }

    dataToSubmit(){
        return {
            description: this.description,
            vehicle_plate: this.vehiclePlate,
            vin: this.getDataForNulleableText(this.vin),
            vehicle_type: this.getDataAvoidErrors(this.vehicleType),
            sim_id: this.selectedSim !== null ? this.selectedSim['id'] : null,
            device_type: this.getDataAvoidErrors(this.deviceType),
            send_im: this.send_im,
            siporal_broadcast: this.siporal_broadcast,
            work_area_calculation: this.workAreaCalculation,
            greenmile_id: this.greenmileNumber,
            mh_broadcast_id: this.mhBroadcastNumber,
            debug: this.debug,
            companies: this.preselectOptions.map(company => Number(company.id)),
            latu_regid: this.getDataForNulleableText(this.latu_regid),
        }
    }


      postVehicle() {
        this.pendingLoadingDialog('Creando vehículo...');

        SettingsService.postVehicle(this.dataToSubmit())
            .then(response => {
                
                this.$router.push(NAME_ROUTES.VEHICLES.path);
                this.updateVehiclesList();
                this.handleSuccessAction(response);
                this.closeModal();
                EventBus.$emit(TypeEventBus.CALL_COMPANIES_ON_HOME_PAGE);
                
            })
            .catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo crear el vehículo'
                })
            });
    }

    patchVehicle() {
        this.pendingLoadingDialog('Modificando vehículo...');

        SettingsService.patchVehicle(this.vehicleToEditId, this.dataToSubmit())
            .then(response => {
                this.$router.push(NAME_ROUTES.VEHICLES.path);
                this.updateVehiclesList();
                this.handleSuccessAction(response);
                EventBus.$emit(TypeEventBus.CALL_COMPANIES_ON_HOME_PAGE);
                this.closeModal();
            })
            .catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo modificar el vehiculo'
                })
            });
    }
}
